// extracted by mini-css-extract-plugin
export default {"planConnector":"ConfirmStep_planConnector__dM8ii","planConnectorIcon":"ConfirmStep_planConnectorIcon__-eMYY"};